export default "__VITE_ASSET__1e686329__"